import React from 'react'

import { isLatLng } from "../../../helpers/isLatLng"

export default function FilterLabel({ selection, updateSelection, updateSearchTerms }) {

  let label = ''
  let groupMode = false

  if ( selection.text ) {

    const removeSearchTerms = () => {
      updateSearchTerms(
        {
          value: '',
        },
        'remove',
      )
    }

    const isLocationSearchText = isLatLng(selection.text)

    return (
      <div className="c-searchSelection">
          <div className="c-searchSelection__inner"><i className="c-searchSelection__removeBtn icon ion-ios-close-circle" onClick={() => removeSearchTerms()}></i>{isLocationSearchText ? 'Your location' : selection.text}</div>
        </div>
    )

  }
  let { field, condition, value } = selection
  const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']

  if ( selection.filters ) {
    groupMode = true;
    field = selection.filters[0].field;
    condition = selection.filters[0].condition;
  }

  switch(field) {
    case 'cuisines.description':
      label = value
      break;
    case 'awards.name':
      label = selection.filters[0].value
      break;
    case 'ambiences.description':
      label = value
      break;
    case 'name':
      label = value
      break;
    case 'private_dining_rooms.min_capacity':
      label = `Private Dining (min: ${selection.filters[0].value}, max: ${selection.filters[1].value})`
      break;
    case 'membership_validities.meal.name':
      label = `Club offer (${selection.filters[0].value} - ${days[selection.filters[1].value]})`
      break;
    case 'limited_edition_bool':
      label = `Club offers only`
      break;
  }

  const removeFilter = () => {
    updateSelection(
      selection,
      'remove',
    )
  }

  return (
    <div className="c-searchSelection">
      <div className="c-searchSelection__inner"><i className="c-searchSelection__removeBtn icon ion-ios-close-circle" onClick={removeFilter}></i>{label}</div>
    </div>
  )
}
